<div class="eventq-toggle-tab" role="tablist">
  @for (item of items(); track item.id) {
    <button
      type="button"
      role="tab"
      class="eventq-toggle-tab__item"
      [class.eventq-toggle-tab__item--active]="item.id === activeId()"
      [attr.aria-selected]="item.id === activeId()"
      (click)="activeIdChange.emit(item.id)"
    >
      @if (item.iconSrc) {
        <span
          class="eventq-toggle-tab__icon eventq-toggle-tab__icon--src"
          [style.--eventq-toggle-tab-icon]="iconStyle(item.iconSrc)"
          aria-hidden="true"
        ></span>
      } @else if (item.icon) {
        <mat-icon class="eventq-toggle-tab__icon">{{ item.icon }}</mat-icon>
      }
      <span>{{ item.label }}</span>
      @if (item.badgeCount) {
        <span class="eventq-toggle-tab__badge">{{ item.badgeCount }}</span>
      }
    </button>
  }
</div>
